import dayjs from 'dayjs';
import type { TFunction } from 'i18next';
import NumberUtil from 'utils/number';

/** "value in previous period" caption for the overview/report summary tiles. */
export function getOverviewComparisonCaption(
  t: TFunction,
  previousValue: number | null | undefined,
  isComparisonEnabled: boolean,
): string | undefined {
  if (!isComparisonEnabled || previousValue == null) {
    return undefined;
  }
  return t('analyticsPerformance.metrics.valueInPreviousPeriod', {
    value: NumberUtil.compact(previousValue),
  });
}

/** Formats a summary date range as `MMM D – MMM D, YYYY`. */
export function formatAnalyticsPeriodLabel(
  since?: string,
  until?: string,
): string {
  if (!since || !until) {
    return '';
  }
  return `${dayjs(since).format('MMM D')} – ${dayjs(until).format(
    'MMM D, YYYY',
  )}`;
}
